export * from './layer';
export * from './layer.interface';
export * from './image-layer';
export * from './image-layer.interface';
export * from './tile-layer';
export * from './tile-layer.interface';
export * from './vector-layer';
export * from './vector-layer.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/layer/shared/layers/index.ts